import * as paths from 'adminConstants/routes';
import { AdminUserRealm } from 'further-types/admin-user';
import useAuth from 'hooks/auth/useAuth';
import { matchPath, useLocation } from 'react-router-dom';

const newLayoutPages: Array<string> = [
  paths.TRANCHE_REDESIGN,
  paths.TRANCHE_ADD_REDESIGN,
];

const newLayoutMatches: Array<string> = [paths.TRANCHE_EDIT_REDESIGN];

export default function useIsNewLayoutPage() {
  const { realm } = useAuth();
  const { pathname } = useLocation();

  if (realm === AdminUserRealm.Lp) {
    return true;
  }

  const isRouteMatch = newLayoutMatches.some((path) =>
    matchPath(pathname, { path }),
  );

  return isRouteMatch || newLayoutPages.includes(pathname);
}
